<div class="pagination_main d-print-none" *ngIf="collectionSize > 0" [ngClass]="{ 'm-2': smallerSize === false }">
  <ngb-pagination
    [(page)]="page"
    [pageSize]="perPage"
    [collectionSize]="collectionSize"
    [maxSize]="maxSize"
    [boundaryLinks]="boundaryLinks"
    [size]="pgSize"
    [ellipses]="ellipses"
    [rotate]="rotate"
    (pageChange)="onPageChange($event)"
  >
    <ng-template ngbPaginationFirst>
      <span title="First page" class="d-flex align-items-center">
        <i class="fas fa-chevron-left arrow-icon"></i>
        <i class="fas fa-chevron-left arrow-icon"></i>
      </span>
    </ng-template>
    <ng-template ngbPaginationPrevious>
      <span title="Previous page" class="d-flex align-items-center">
        <i class="fas fa-chevron-left arrow-icon"></i>
      </span>
    </ng-template>
    <ng-template ngbPaginationEllipsis>
      <span title="Continue"> ... </span>
    </ng-template>
    <ng-template ngbPaginationNext>
      <span title="Next page" class="d-flex align-items-center">
        <i class="fas fa-chevron-right arrow-icon"></i>
      </span>
    </ng-template>
    <ng-template ngbPaginationLast>
      <span title="Last page" class="d-flex align-items-center">
        <i class="fas fa-chevron-right arrow-icon"></i>
        <i class="fas fa-chevron-right arrow-icon"></i>
      </span>
    </ng-template>
  </ngb-pagination>

  <div class="d-flex flex-row align-dropdown" title="{{ pageChangeSizeLabel }}" *ngIf="hideLimitDropdown !== true">
    <label class="align-dropdown-label" [ngClass]="{ 'sm-label': smallerSize === true }">{{ pageChangeSizeLabel }}</label>
    <div class="dropdown">
      <a
        class="btn dropdown-toggle btn-sm default-font"
        role="button"
        id="pagination_btn"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        <span class="page_count">
          {{ perPageValue }}
        </span>
      </a>

      <div class="dropdown-menu" aria-labelledby="pagination_btn">
        <ng-container *ngFor="let limit of pageLimitOptions">
          <a
            class="dropdown-item default-pointer"
            [ngClass]="{ 'active-selection': perPageValue === limit, hide: collectionSize < limit }"
            (click)="selectPaginationLimit(limit)"
            >{{ limit }}</a
          >
        </ng-container>
        <a
          class="dropdown-item default-pointer"
          [ngClass]="{ 'active-selection': perPageValue === 'All', hide: collectionSize > 1000 && restrictAllOption === true }"
          (click)="selectPaginationLimit('')"
          >All</a
        >
      </div>
    </div>
  </div>
</div>
